import { commonClient } from 'src/libraries/http.library';
import { FooterSchema, NotificationSchema } from 'src/models/util.model';

const common = commonClient();

const services = {
  footerGET: async () => {
    return common.get(
      `/footers?appId=${process.env.REACT_APP_CMDB_ID}&attachcompanyinfo=1`,
      {},
      FooterSchema,
    );
  },
  notifGET: async () => {
    return common.get(
      `/notifications?appId=${process.env.REACT_APP_CMDB_ID}`,
      {},
      NotificationSchema,
    );
  },
};

export default services;
